import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksAllLogisticWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS,
		dtConfig[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS].getDoneWorksAllLogisticWorks,
		{
			urlParams: {
				companyId,
			},
			params: query,
		}
	)
}

export default {
	getDoneWorksAllLogisticWorks,
}
